import { useMutation } from 'react-query';

import api from '@root/api';

export default function useGenerateReferralCode() {
  return useMutation(
    () => api.company.generateReferralCode(),
  );
}
